export default __webpack_public_path__ + "static/char-thumb-52-33e82f3d3452045515175e80878f11c2.png";